import { API_ORIGIN } from '@/lib/config';
/**
 * Utility to get full image URL from stored path
 * Handles both relative (/api/uploads/xxx.png) and absolute URLs
 * This ensures images work correctly across different environments (preview, production)
 */
export const getImageUrl = (url) => {
  if (!url) return '';
  
  // If already absolute URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If relative URL, prepend API base
  const baseUrl = API_ORIGIN;
  return `${baseUrl}${url}`;
};

/**
 * Get initials from a name for avatar fallback
 */
export const getInitials = (name) => {
  if (!name) return 'U';
  return name.charAt(0).toUpperCase();
};
